/**
 * Subject metadata — bridges the DB enum (snake_case)
 * and the CSS token ids (kebab-case), plus the Kazakh display labels.
 *
 * Any component that renders a subject badge / chip / color should
 * pull its token id and label from here.
 */

export type SubjectId =
  | 'history'
  | 'world_history'
  | 'biology'
  | 'chemistry'
  | 'physics'
  | 'informatics'
  | 'geography'
  | 'english'
  | 'kazakh_language'
  | 'kazakh_literature'
  | 'russian_language_and_literature'
  | 'law_basics';

export interface SubjectMeta {
  id: SubjectId;
  /** Kebab-case id used in CSS token names: --subject-{token}-h-s-l */
  token: string;
  /** Kazakh display label */
  label: string;
  /** Short label for tight chips */
  short: string;
}

export const SUBJECTS: SubjectMeta[] = [
  { id: 'history',                         token: 'history',           label: 'Қазақстан тарихы',      short: 'Қаз. тарихы' },
  { id: 'world_history',                   token: 'world-history',     label: 'Дүниежүзі тарихы',      short: 'Дүн. тарихы' },
  { id: 'biology',                         token: 'biology',           label: 'Биология',              short: 'Биология' },
  { id: 'chemistry',                       token: 'chemistry',         label: 'Химия',                 short: 'Химия' },
  { id: 'physics',                         token: 'physics',           label: 'Физика',                short: 'Физика' },
  { id: 'informatics',                     token: 'informatics',       label: 'Информатика',           short: 'Информ.' },
  { id: 'geography',                       token: 'geography',         label: 'География',             short: 'Геогр.' },
  { id: 'english',                         token: 'english',           label: 'Ағылшын тілі',          short: 'Ағылшын' },
  { id: 'kazakh_language',                 token: 'kazakh-language',   label: 'Қазақ тілі',            short: 'Қаз. тілі' },
  { id: 'kazakh_literature',               token: 'kazakh-literature', label: 'Қазақ әдебиеті',        short: 'Қаз. әдеб.' },
  { id: 'russian_language_and_literature', token: 'russian',           label: 'Орыс тілі мен әдебиеті', short: 'Орыс тілі' },
  { id: 'law_basics',                      token: 'law',               label: 'Құқық негіздері',        short: 'Құқық' }
];

const BY_ID = new Map<string, SubjectMeta>(SUBJECTS.map((s) => [s.id, s]));

export function getSubjectMeta(id: string | null | undefined): SubjectMeta | null {
  if (!id) return null;
  return BY_ID.get(id) ?? null;
}

export function subjectLabel(id: string | null | undefined): string {
  return getSubjectMeta(id)?.label ?? (id ?? '');
}

export function subjectToken(id: string | null | undefined): string | null {
  return getSubjectMeta(id)?.token ?? null;
}
